import { styled } from '@linaria/react';

import { visualHideScrollbar } from '~shared/ui/theme/snippets';

export const GridCarouselItem = styled.div`
	position: absolute;
	z-index: -1;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	min-height: 0;
	flex: 0 0 100%;
	pointer-events: none;
	img {
		width: 100%;
		height: 100%;
		background: var(--color-black-solid);
		object-fit: cover;
		object-position: center;
	}
`;

export const CarouselList = styled.div`
	${visualHideScrollbar};
	position: absolute;
	z-index: 0;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	content-visibility: auto;
	@keyframes fadeInLoop {
		0% {
			opacity: 0;
		}
		8.33% {
			opacity: 1;
		}
		41.67% {
			opacity: 1;
		}
		50% {
			opacity: 0;
		}
		100% {
			opacity: 0;
		}
	}

	${GridCarouselItem} {
		&:not(:first-child) {
			opacity: 0;
		}
		&:first-child {
			z-index: 1;
		}
		&:nth-child(2) {
			z-index: 2;
		}
		&:nth-child(3) {
			z-index: 3;
		}
	}

	/* hide not needed imgs so they wont be loaded on initial load */
	/* for 2nd img container leave preview */
	/* for 3rd hide both */
	&:not(:hover) {
		${GridCarouselItem} {
			&:nth-child(2) {
				img:nth-child(2) {
					display: none;
				}
			}
			&:nth-child(3) {
				img {
					display: none;
				}
			}
		}
	}
	&:hover {
		${GridCarouselItem} {
			&:not(:first-child) {
				animation: fadeInLoop 6s linear infinite;
			}

			&:nth-child(2) {
				animation-delay: 0.1s;
			}

			&:nth-child(3) {
				animation-delay: 2.1s;
			}
		}
	}
	&:focus {
		${GridCarouselItem} {
			&:not(:first-child) {
				animation: fadeInLoop 6s linear infinite;
			}

			&:nth-child(2) {
				animation-delay: 0.1s;
			}

			&:nth-child(3) {
				animation-delay: 2.1s;
			}
		}
	}
`;
